import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import useDebounce from '@hooks/useDebounce';
import { Table, TableSize } from '@ui/molecules/Table';
import { Loader } from '@ui/atoms/Loader';
import { Text } from '@ui/atoms/Text';
import SearchPanel from '@components/SearchPanel';
import getColumnsDefinition from './columns';
import useTerritories from './hooks/useTerritoriesQuery';
import { namespace } from './constants';
import { newTerritoryPath } from '../../../routes';
import './TerritoriesStyles.scss';
const TERRITORIES_PAGE_SIZE = 50;
function TerritoriesContainer() {
    const [searchText, setSearchText] = useState('');
    const searchTextDebounced = useDebounce(searchText);
    const { territories, loading } = useTerritories(searchTextDebounced);
    return (React.createElement("div", { className: "workspace__major--form" },
        React.createElement("header", { className: "workspace__header--alt--sticky" },
            React.createElement("div", { className: "header__main" },
                React.createElement(Text, { variant: "x-large", as: "h1" }, translate('title', { namespace })))),
        React.createElement("section", { className: "territories-settings-container" },
            React.createElement("article", { id: "filters", className: "qmb-filters territories-settings__filters" },
                React.createElement("a", { href: newTerritoryPath(), className: "qmb-control mt-1" },
                    React.createElement("i", { className: "fa-light fa-circle-plus" }),
                    translate('add_button', { namespace })),
                React.createElement("div", { className: "filters__group--search" },
                    React.createElement(SearchPanel, { value: searchText, placeholder: translate('search', { namespace: 'filters' }), onChange: setSearchText }))),
            React.createElement("div", { className: "territories-settings__table-shell" },
                loading && (React.createElement("div", { className: "territories-settings__loading" },
                    React.createElement(Loader, { size: "64" }))),
                !loading && (React.createElement(Table, { columns: getColumnsDefinition(), data: territories, size: TableSize.Full, variant: "listing", paginated: true, pageSize: TERRITORIES_PAGE_SIZE })),
                !loading && territories.length === 0 && (React.createElement("div", { className: "territories-settings__no-data" }, translate('no_data', { namespace })))))));
}
export default TerritoriesContainer;
